import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import svgicon from "vue-svgicon";
import Vuelidate from "vuelidate";
import VueTableDynamic from "vue-table-dynamic";
import VTooltip from "v-tooltip";
import vClickOutside from 'v-click-outside'

import "@/assets/icons";
import "@/assets/styles/main.scss";

// Extensions
import "@/utils/extensions/string.js";

// Filters
import dateFilters from "@/utils/filters/dateFilters.js";
import formatFilters from "@/utils/filters/formatFilters.js";
import stringFilters from "@/utils/filters/stringFilters.js";

const filters = {
  ...dateFilters,
  ...formatFilters,
  ...stringFilters,
};

Object.entries(filters).forEach(([key, value]) => {
  Vue.filter(key, value);
});

// Plugins
Vue.use(vClickOutside);
Vue.use(Vuelidate);
Vue.use(VueTableDynamic);
Vue.use(VTooltip);
Vue.use(svgicon, {
  tagName: "svgicon",
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
